import script from "./TextFree.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextFree.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__